/**
 * Created by sdielmann on 30.11.2017.
 */
import { Component, ContentChildren, Input, QueryList } from '@angular/core';
import { AfterContentInit } from '@angular/core';
import { filter, takeUntil } from 'rxjs/operators';
import { MuiAccordion } from './mui-accordion.component';

@Component({
  selector: 'mui-accordion-group',
  styles: [`:host {
    display: block;
  }`],
  template: '<ng-content></ng-content>'
})
export class MuiAccordionGroup implements AfterContentInit {

  @Input() single = true;

  @ContentChildren(MuiAccordion, {descendants: true})
  accordionElements: QueryList<MuiAccordion> = new QueryList();

  ngAfterContentInit(): void {
    this.processAccordionList(this.accordionElements.toArray());
    this.accordionElements.changes.subscribe(this.processAccordionList);
  }

  expandSingle(item: MuiAccordion) {
    if (this.single) {
      this.accordionElements.forEach((current) => {
        if (current !== item && current.expanded) {
          current.expanded = false;
        }
      });
    }
  }

  private processAccordionList = (list: MuiAccordion[]) => {
    list.forEach((item: MuiAccordion) => {
      item.toggle
        .pipe(
          takeUntil(this.accordionElements.changes),
          filter(next => next === true)
        ).subscribe(() => this.expandSingle(item));
    });
  };
}
